import React from 'react';
import PropTypes from 'prop-types';
import { Marquee } from './../marquee';
import { Icon } from './../../../ui/src/component/icon';
import './liveStreamWidget.css';

const LiveStreamWidget = props => {
  return (
    <div className="live-stream-widget">
      {props.logo} <span className="ls-text">Live stream</span>
      <Marquee text={props.currentSong} />
      <span className="play-btn">
        <Icon name="play" />
      </span>
    </div>
  );
};

LiveStreamWidget.defaultProps = {
  currentSong: '',
};

LiveStreamWidget.propTypes = {
  currentSong: PropTypes.string,
  logo: PropTypes.node.isRequired,
};

export default LiveStreamWidget;



// WEBPACK FOOTER //
// ./src/app/component/liveStreamWidget/liveStreamWidget.js